/** `dockerDeployTarget` — the shared container runtime bound to the `docker` bin. */

import { makeContainerDeployTarget } from "./container-runtime.js";

export const dockerDeployTarget = makeContainerDeployTarget("docker");
